(function ($) {
    var toggleSelector = '-visible';
    if($('.h-overlay.-visible').length > 0) {
        $('body').addClass('h-overlay__open');
    }
    $.fn.overlay = function($el) {
        $(this).toggleClass(toggleSelector);
        $(this).attr('aria-hidden', (i, attr) => {
            return attr === 'true' ? 'false' : 'true';
        });
        if($($($el).data('target')).attr('aria-hidden') === 'false') {
            $('body').addClass('h-overlay__open');
        } else {
            $('body').removeClass('h-overlay__open');
        }
    };
}(jQuery));



// WEBPACK FOOTER //
// ./src/app/components/overlay/overlay.authoring.js